import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Card, CardBody, CardHeader, Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Input } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { Switch } from 'antd';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';

// Local Deps
import './toolingLocationsSearch.scss';
// Components
import ToolingSearchForm from '../../forms/ToolingSearch';
import ToolingLocationsSearchGrid from '../../grids/ToolingLocationsSearchGrid';


class ToolingLocationSearch extends React.PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    searchReset: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    initialValues: PropTypes.shape({
      niin: PropTypes.string,
      partNum: PropTypes.string,
      description: PropTypes.string,
      wsdc: PropTypes.string,
      searchCage: PropTypes.string,
      solicitation: PropTypes.string,
    }).isRequired,
    searchTypeIsT: PropTypes.bool.isRequired,
    sohGreaterThan0: PropTypes.bool.isRequired,
    searchTypeIsP: PropTypes.bool.isRequired,
    toggleFilterCriteria: PropTypes.func.isRequired,
    toolFilter: PropTypes.array,
    onChangeField: PropTypes.func.isRequired,
    disableSearchButtons: PropTypes.bool.isRequired,
    updateDisableSearchButtons: PropTypes.func.isRequired,
    isCoreOnly: PropTypes.bool,
    showSuccessModal: PropTypes.bool,
    toggleSuccessModal: PropTypes.func,
    coreSubmitting: PropTypes.bool,
  };

  static defaultProps = {
    toolFilter: undefined,
    isCoreOnly: false,
    showSuccessModal: false,
    toggleSuccessModal: () => { },
    coreSubmitting: false,
  };
  render() {
    const {
      handleSubmit,
      searchReset,
      initialValues,
      auth,
      searchTypeIsT,
      sohGreaterThan0,
      searchTypeIsP,
      toggleFilterCriteria,
      toolFilter,
      onChangeField,
      disableSearchButtons,
      updateDisableSearchButtons,
      isCoreOnly,
      showSuccessModal,
      toggleSuccessModal,
      coreSubmitting,
    } = this.props;
    return (
      <div className="nf-tooling-location-search">
        <Card className="item-search-criteria-card">
          <CardHeader>
            <Row>
              <Col xs="4">
                <Switch
                  checkedChildren={<CheckOutlined />}
                  unCheckedChildren={<CloseOutlined />}
                  checked={searchTypeIsT}
                  disabled={disableSearchButtons}
                  onChange={(e) => toggleFilterCriteria(e, "searchTypeIsT")}
                  name="searchTypeIsT"
                />
                <span className="switch-label">Items with Tooling Only</span>
              </Col>
              <Col xs="4">
                <Switch
                  checkedChildren={<CheckOutlined />}
                  unCheckedChildren={<CloseOutlined />}
                  checked={sohGreaterThan0}
                  disabled={disableSearchButtons}
                  onChange={(e) => toggleFilterCriteria(e, "sohGreaterThan0")}
                  name="sohGreaterThan0"
                />
                <span className="switch-label">Items with Stock On Hand (SOH) Only</span>
              </Col>
              <Col xs="4">
                <Switch
                  checkedChildren={<CheckOutlined />}
                  unCheckedChildren={<CloseOutlined />}
                  checked={searchTypeIsP}
                  disabled={disableSearchButtons}
                  onChange={(e) => toggleFilterCriteria(e, "searchTypeIsP")}
                  name="searchTypeIsP"
                />
                <span className="switch-label">Search Procurement History Only</span>
              </Col>
            </Row>
          </CardHeader>
          <CardBody style={{ justifyContent: 'center' }}>
            {isCoreOnly && (
              <FormGroup style={{ marginBottom: '1rem' }}>
                <Label for="userEmail" style={{ fontWeight: '600' }}>Your Email Address</Label>
                <Input
                  type="email"
                  id="userEmail"
                  value={auth.email || ''}
                  readOnly
                  disabled
                  style={{ backgroundColor: '#e9ecef' }}
                />
              </FormGroup>
            )}
            <ToolingSearchForm
              onSubmit={handleSubmit}
              searchReset={searchReset}
              initialValues={initialValues}
              searchTypeIsP={searchTypeIsP}
              onChangeField={onChangeField}
              disableSearchButtons={disableSearchButtons || coreSubmitting}
              submitLabel={isCoreOnly ? 'Submit Request' : undefined}
              isCoreOnly={isCoreOnly}
            />
          </CardBody>
        </Card>
        {!isCoreOnly && (
          <React.Fragment>
            <Row />{' '}
            <div className="nf-tooling-location__grid">
              {toolFilter &&
                <ToolingLocationsSearchGrid
                  auth={auth}
                  toolFilter={toolFilter}
                  updateDisableSearchButtons={updateDisableSearchButtons}
                />
              }
            </div>
          </React.Fragment>
        )}
        <Modal isOpen={showSuccessModal} toggle={toggleSuccessModal} centered>
          <ModalHeader toggle={toggleSuccessModal}>Request Submitted</ModalHeader>
          <ModalBody>
            <p>Your search results will be emailed to <strong>{auth.email}</strong> shortly.</p>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={toggleSuccessModal}>OK</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}



export default withRouter(ToolingLocationSearch);



// WEBPACK FOOTER //
// ./src/components/ToolingLocations/ToolingLocationsSearch/ToolingLocationSearch.jsx